import { EditOutlined } from '@mui/icons-material';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { EmailTemplateSectionProps } from './EmailTemplateSection.props';

const EmailTemplateSection = ({
  idPrefix,
  templateSelectLabel,
  templates,
  selectedTemplateId,
  setSelectedTemplateId,
  emailSubject,
  onConfigure,
}: EmailTemplateSectionProps) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      p: 1.5,
    }}>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      Email template
    </Typography>
    <Stack spacing={1.25}>
      <FormControl size="small" fullWidth>
        <InputLabel id={`${idPrefix}-template-label`}>{templateSelectLabel}</InputLabel>
        <Select
          labelId={`${idPrefix}-template-label`}
          id={`${idPrefix}-template`}
          label={templateSelectLabel}
          value={selectedTemplateId}
          onChange={event => setSelectedTemplateId(event.target.value)}
          MenuProps={{
            disablePortal: true,
            PaperProps: { sx: { maxHeight: 320 } },
          }}>
          {templates.map(template => (
            <MenuItem key={template.id} value={template.id}>
              {template.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {emailSubject ? (
        <Typography variant="caption" color="text.secondary">
          Subject: {emailSubject}
        </Typography>
      ) : null}

      <Button
        startIcon={<EditOutlined />}
        onClick={onConfigure}
        size="small"
        variant="outlined"
        sx={{ alignSelf: 'flex-start' }}
        id={`${idPrefix}-configure-template-button`}>
        Configure email template
      </Button>
    </Stack>
  </Box>
);

export default EmailTemplateSection;
